import { Controller, useFormContext } from "react-hook-form";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";

type Option = { value: string; label: string; disabled?: boolean };

type RHFRadioGroupProps = {
  name: string;
  label?: string;
  options: Option[];
  inline?: boolean;
};

const RHFRadioGroup = ({ name, label, options, inline }: RHFRadioGroupProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const err = (errors as any)?.[name]?.message as string | undefined;

  return (
    <FormGroup  className="mb-2">
      {label && <Label className="d-block mb-1">{label}</Label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <div className={`d-flex ${inline ? "flex-row" : "flex-column"} gap-3`}>
            {options.map((opt) => (
              <FormGroup check inline={inline} key={opt.value}>
                <Label check className="d-flex align-items-center gap-1">
                  <Input
                    type="radio"
                    value={opt.value}
                    checked={field.value === opt.value}
                    onChange={() => field.onChange(opt.value)}
                    disabled={opt.disabled}
                    invalid={!!err}
                    className="radio_animated"
                  />
                  {opt.label}
                </Label>
              </FormGroup>
            ))}
          </div>
        )}
      />
      {err && <FormFeedback className="d-block">{err}</FormFeedback>}
    </FormGroup>
  );
};

export default RHFRadioGroup;
